import { makeStyles } from "tss-react/mui";
import { MiActions, MiBox } from "@miplatform/components";
import { Box, Typography } from "@mui/material";
import { AreaTemplates } from "./components/AreaTemplates/AreaTemplates";
import { CopyExistingPlans } from "./components/CopyExistingPlans/CopyExistingPlans";
import { useCreateBidContext } from "../CreateBidContext";
import { START_OPTION } from "../constants";

export function StartingPoint() {
  const { classes, cx } = useStyles();
  const { startOption, setStartOption, form } = useCreateBidContext();
  const { setValue } = form;

  const optionConfigs = [
    {
      id: START_OPTION.SCRATCH,
      title: "Start From Scratch",
      description: "Create floors and areas from scratch",
      onClick: () => {
        setValue("planAreas", []);
        setStartOption(START_OPTION.SCRATCH);
      },
    },
    {
      id: START_OPTION.AREA_TEMPLATES,
      title: "Area Templates",
      description: "Start with predefined floors and areas",
      onClick: () => setStartOption(START_OPTION.AREA_TEMPLATES),
    },
    {
      id: START_OPTION.COPY,
      title: "Copy From Existing Plans",
      description: "Start with predefined floors, areas, and items",
      onClick: () => {
        setValue("planAreas", []);
        setStartOption(START_OPTION.COPY);
      },
    },
  ];

  const options = optionConfigs.map((option) => ({
    name: (
      <Box>
        <Typography className={classes.actionTitle}>{option.title}</Typography>
        <Typography variant="caption" color="textSecondary">
          {option.description}
        </Typography>
      </Box>
    ),
    onClick: option.onClick,
    className: cx(
      classes.actionBtn,
      startOption === option.id && classes.startOption
    ),
  }));

  return (
    <MiBox headerTitle="Bid Starting Point">
      <Box className={classes.actionBox}>
        <MiActions actions={options} />
      </Box>
      <AreaTemplates open={startOption === START_OPTION.AREA_TEMPLATES} />
      <CopyExistingPlans open={startOption === START_OPTION.COPY} />
    </MiBox>
  );
}

const useStyles = makeStyles()((theme) => ({
  actionBox: {
    width: "100%",
    display: "flex",
    gap: theme.spacing(2),
  },
  actionTitle: {
    fontWeight: theme.fontWeight.semiBold,
    color: theme.palette.common.black,
  },
  actionBtn: {
    border: `1px solid ${theme.palette.grey.accent}`,
    width: "100%",
    backgroundColor: theme.palette.grey.light,
  },
  startOption: {
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primary.light,
  },
}));
